<template>
  <ImportDialog
    :apply="apply"
    :create-file-handler="createFileHandler"
    :files.sync="files"
    :files-types="['xlsx']"
    only_one
    @close="close">
    <template #activator="{ open }">
      <sTooltip
        :border="false"
        :content="$t('Tenders.FeatureNotAvailableOnYourTariff')"
        :disabled="$can('import', 'lots')">
        <div>
          <sButton
            :class="btn_class || ' mr-3 ml-auto'"
            :disabled="loadImportLots || disabled || (tender && !$can('import', 'lots'))"
            icon="import"
            :loading="loadImportLots"
            type="text"
            @click="open">
            {{ $t('Tenders.ImportXLS') }}
          </sButton>
        </div>
      </sTooltip>
    </template>
    <template #actions>
      <div class="width-100">
        <sButton
          class="mb-1"
          icon="download"
          :loading="template && !template.file"
          type="text"
          @click="downloadTemplate">
          {{ $t('Tenders.DownloadXLSTemplate') }}
        </sButton>
        <div
          v-if="tender"
          class="h8-text">
          {{ $t('Tenders.AnotherForEveryTender') }}
        </div>
      </div>
    </template>
  </ImportDialog>
</template>
<script>
import ImportDialog from 'components/common/dialogs/ImportDialog.vue'

import { XlsImportCartTemplateFile, XlsImportCartFile, TenderLotTemplateFile, TenderLotFile } from '@/types/commonFile.js'
import { eventBus } from '@/main'

export default {
  name: 'importXls',
  data() {
    return {
      files: [],
      load: false,
      loadImportLots: false,
      template: null
    }
  },
  props: {
    element: Array,
    btn_class: String,
    disabled: Boolean,
    tender: Object
  },
  mounted() {
  },
  computed: {
    loading() {
      return this.files?.some((e) => e.loading)
    },
  },
  methods: {
    apply() {
      if (this.tender) {
        this.loadImportLots = true
        this.$emit('startImportLots')
        this.files[0]?.uploadFile()
          .then((res) => {
            if (res.data?.errors?.length) {
              eventBus.$emit('showErrorSnackbar', res.data.errors)
              this.close()
              return
            }
            let ret = res.data?.data?.editTenderDraftWithImportLots
            this.$emit('onSubmitTender', ret)
            this.close()
          })
          .catch(er => {
            this.$emit('finishImportLots')
            this.$log_error(er.response.data)
          })
          .finally(() => {
            this.$emit('finishImportLots')
            this.loadImportLots = false
            this.files = this.files.map(file => {
              this.$set(file, 'loading', false)
              this.$set(file, 'uploadPercentage', null)
              return file
            })
          })
        return
      }

      let promices = this.files.map(file => {
        return file.uploadFile()
      })

      Promise.all(promices)
        .then((res) => {
          let ret = []
          res.forEach(file => {
            ret.push(...file.data)
          })
          this.$emit('onSubmit', ret)
          this.close()
        })
        .catch(er => {
          this.$log_error(er.response.data)
        })
        .finally(() => {
          this.files = this.files.map(file => {
            this.$set(file, 'loading', false)
            this.$set(file, 'uploadPercentage', null)
            return file
          })
        })
    },
    close() {
      this.files = []
    },
    downloadTemplate() {
      if (this.tender) {
        const uri = window.config.GrapgQlUrl + '/files/getLotImportTemplate/' + this.tender.tenderId
        this.template = new TenderLotTemplateFile(uri, this.$t('Common.templateImportLots'))
      } else {
        this.template = new XlsImportCartTemplateFile()
      }
      try {
        this.template.saveFile()
      } catch (_) {
        this.template = null
      }
    },
    createFileHandler(file) {
      if (this.tender) {
        return new TenderLotFile(file, this.tender.tenderId, 'uploadLotsWithAdditional')
      }
      return new XlsImportCartFile(file)
    }
  },
  components: {
    ImportDialog
  }
}
</script>
